import "./style/index.scss";
import App from "./components/app";
import { hydrate, prerender as ssr } from "preact-iso";
import * as Sentry from "@sentry/react";
import prerenderData from "../prerender-urls.json";
import { pageEntry } from "./types";
import { Suspense } from "preact/compat";

const RELOAD_TIME = 1000 * 60 * 60 * 24; // if resuming a page that's more than a day old, need to refresh for latest content
const PAGE_LOAD_TIME = Date.now();

if (typeof window !== "undefined") {
  const entry = document.getElementById("app");
  if (entry) {
    const timeSinceLoad = () => Date.now() - PAGE_LOAD_TIME;
    if (import.meta.env.DEV !== true) {
      Sentry.init({
        dsn: "https://cf47ba0c2248b4f28f4c747ff623db75@o4509376542998528.ingest.us.sentry.io/4509376545226752",
        sendDefaultPii: true,
        integrations: [
          Sentry.captureConsoleIntegration(),
          Sentry.replayIntegration(),
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
      });
      window.addEventListener("offline", () =>
        Sentry.addBreadcrumb({
          message: "Browser is offline",
          level: "warning",
        })
      );
      window.addEventListener("online", () =>
        Sentry.addBreadcrumb({ message: "Browser is online", level: "info" })
      );
      window.addEventListener("visibilitychange", () =>
        Sentry.addBreadcrumb({
          message:
            "Visibility change to " +
            document.visibilityState +
            " after " +
            timeSinceLoad() / 1000 +
            "s",
          level: "info",
        })
      );
    }

    const checkReload = () => {
      // if page is stale in a tab or minimised browser, need to refresh. Can only do that if online though
      if (timeSinceLoad() > RELOAD_TIME && window.navigator.onLine) {
        location.reload();
      }
    };
    window.addEventListener("visibilitychange", checkReload);
    window.addEventListener("online", checkReload);

    hydrate(
      <Suspense fallback={"Loading..."}>
        <App />
      </Suspense>,
      entry
    );
  }
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export async function prerender(data: any) {
  const { html, links: discoveredLinks } = await ssr(<App {...data} />);

  const publicPageURLs = (prerenderData as pageEntry[])
    .filter((page) => page.url && (page.role === "person" || !page.role))
    .map((page) => page.url as string);

  return {
    html,
    links: new Set([...Array.from(discoveredLinks || []), ...publicPageURLs]),
  };
}
